import React from 'react';
import { useState, useEffect } from 'react';
import { Modal, Form, Spinner } from 'react-bootstrap';
import { X } from 'react-bootstrap-icons';
import { Workstation } from '../../../../../types';
import { toast } from 'react-toastify';
import { updateWorkstationById } from '../../../../../../../../crud/management_api/workstations';
import SearchDropdown from '../../../../../../../../components/common/SearchDropdown/SearchDropdown';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { HiOutlineInformationCircle } from 'react-icons/hi2';
import { cajaHaveMoneyWithWorkstationId } from '../../../../../../../../crud/management_api/locales_caja_management';
import { IsCajaWithMoney } from './components/IsCajaWithMoney/IsCajaWithMoney';
import { TerminalOption, getTerminalOptions } from './../utils/utils';
import './EditWorkstation.scss';
const EditWorkstation: React.FC<any> = ({
  showEditModal,
  setShowEditModal,
  setCurrentData,
  currentData,
  currentWorkstation,
  isOnlyOneCaja
}) => {
  const [terminals, setTerminals] = useState<TerminalOption[]>([]);
  const [isActive, setIsActive] = useState(true);
  const [isCaja, setIsCaja] = useState(false);
  const [terminalId, setTerminalId] = useState('');
  const [showCajaWithMoneyModal, setShowCajaWithMoneyModal] = useState(false);
  const [pendingEditWorkstation, setPendingEditWorkstation] = useState<any>(null);
  const [isUpdating, setIsUpdating] = useState(false);

  
  
  useEffect(() => {
    if (currentWorkstation) {
      setIsActive(currentWorkstation.state);
      setIsCaja(!!currentWorkstation.isCaja);
      // Handle null/undefined terminal_id by setting to empty string (which maps to "Ninguno")
      setTerminalId(currentWorkstation.default_terminal_id ? String(currentWorkstation.default_terminal_id) : '');
    }
  }, [currentWorkstation]);

  useEffect(() => {
    getTerminalOptions().then((response) => {
      if (response) {
        setTerminals(response);
      }
    });
  }, []);



  const handleCajaChange = (e: any) => {
    if (isOnlyOneCaja && !e.target.checked) {
      toast.error('¡Necesitas al menos una caja para tomar pedidos!');
      return;
    }
    setIsCaja(e.target.checked);
  };

  const handleEditFormSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (isUpdating) return; // Prevent double submissions
    
    const form = e.currentTarget;
    if (!form) {
      console.error('Form not found.');
      return;
    }

    setIsUpdating(true);

    const userContext = localStorage.getItem('user');
    const user_id = userContext != null ? JSON.parse(userContext).user_id : 0;
    const localId = userContext != null ? JSON.parse(userContext).local_id : 0;
    // Handle "Ninguno" selection (empty string) by setting to null
    const default_terminal_id = terminalId === '' || terminalId === 'Ninguno' ? null : Number(terminalId);
    const edit_Workstation: Workstation = {
      workstation_id: currentWorkstation.workstation_id,
      workstation_name: form.workstation_name.value,
      workstation_description: form.workstation_description.value,
      local_id: localId,
      terminal_name: '',
      default_terminal_id,
      state: isActive,
      isCaja: isCaja,
      created_at: currentWorkstation.created_at,
      user_id: user_id
    };

    // Detectar cambio de isCaja true -> false
    if (currentWorkstation.isCaja && !isCaja) {
      // Si solo hay una caja, mostrar error y no continuar
      if (isOnlyOneCaja) {
        toast.error('¡Necesitas al menos una caja para tomar pedidos!');
        setIsUpdating(false);
        return;
      }
      // Consultar si la caja tiene dinero
      try {
        const res = await cajaHaveMoneyWithWorkstationId(Number(currentWorkstation.workstation_id));
        if (res?.data === true || res?.data?.has_money === true) {
          // Mostrar modal de transferencia y guardar el update pendiente
          setPendingEditWorkstation(edit_Workstation);
          setShowCajaWithMoneyModal(true);
          setIsUpdating(false); // Reset loading state since we're showing modal
          return; // No hacer update aún
        }
      } catch (err) {
        toast.error('Error al verificar dinero en caja');
        setIsUpdating(false);
        return;
      }
    }

    // Si no hay dinero o no es cambio de caja->no-caja, hacer update normal
    doUpdateWorkstation(edit_Workstation);
  };

  // Función para hacer el update
  const doUpdateWorkstation = (edit_Workstation: Workstation) => {
    updateWorkstationById(Number(edit_Workstation.workstation_id), edit_Workstation)
      .then(response => {
        toast.success('Estación de trabajo editada con éxito!');
        setShowEditModal(false);
        // remove the old workstation from the data and add the updated one
        edit_Workstation.terminal_name = (response as any).data.terminal_name;
        const updatedData = currentData.filter((workstation: any) => workstation.workstation_id !== currentWorkstation.workstation_id);
        setCurrentData([edit_Workstation, ...updatedData]);
      })
      .catch(error => {
        console.error('Error al editar la estación de trabajo:', error);
        toast.error('Error al editar la estación de trabajo');
      })
      .finally(() => {
        setIsUpdating(false);
      });
  };

  // Callback cuando se cierra el modal de transferencia
  const handleCajaWithMoneyModalClose = (transferDone: boolean) => {
    setShowCajaWithMoneyModal(false);
    if (transferDone && pendingEditWorkstation) {
      setIsUpdating(true); // Set loading state when proceeding with update
      doUpdateWorkstation(pendingEditWorkstation);
    }
    setPendingEditWorkstation(null);
  };

  const TerminalDropdown = (
    <div className="mp-form-group">
      <div className="mp-form-hint">
        <label className="mp-form-label">Terminal por defecto</label>
        <OverlayTrigger
          placement="top"
          overlay={<Tooltip id="terminal-tooltip">Selecciona el terminal predeterminado para esta estación.</Tooltip>}
        >
          <span className="mp-form-hint-icon"><HiOutlineInformationCircle size={16} /></span>
        </OverlayTrigger>
      </div>
      <input type="hidden" name="default_terminal_id" value={terminalId} />
      <SearchDropdown
        items={terminals}
        selected={terminals.find((t) => String(t.id) === String(terminalId)) || null}
        setSelected={(selected: TerminalOption) => setTerminalId(String(selected.id))}
        displayProperty="name"
        idProperty="id"
        placeholder="Selecciona un terminal"
      />
    </div>
  );

  return (
    <>
      <Modal className="modal-edit-workstation" show={showEditModal} onHide={() => setShowEditModal(false)}>
        <Form onSubmit={handleEditFormSubmit}>
          <Modal.Header>
            <div className='form-modal-title-container'>
              <Modal.Title className='form-modal-title'>Actualizar estación de trabajo</Modal.Title>
            </div>
            <button type="button" className="modal-close-button" onClick={() => setShowEditModal(false)}>
              <X size={22} />
            </button>
          </Modal.Header>
          <Modal.Body>
            <div className="px-2 py-1 flex flex-col gap-0">
              <div className="mp-form-group">
                <label className="mp-form-label">Nombre</label>
                <input
                  className="mp-form-input"
                  type="text"
                  name="workstation_name"
                  placeholder="Ej: Caja Principal"
                  defaultValue={currentWorkstation?.workstation_name}
                  required
                />
              </div>

              <div className="mp-form-group">
                <label className="mp-form-label">Descripción</label>
                <textarea
                  className="mp-form-input mp-form-textarea"
                  name="workstation_description"
                  placeholder="Describa brevemente esta estación..."
                  rows={3}
                  defaultValue={currentWorkstation?.workstation_description}
                  required
                />
              </div>

              {TerminalDropdown}

              <div className="mp-form-group">
                <label className="mp-form-checkbox">
                  <input
                    type="checkbox"
                    name="isCaja"
                    checked={isCaja}
                    onChange={handleCajaChange}
                  />
                  <span>Marcar como caja</span>
                </label>
              </div>
            </div>
          </Modal.Body>

          <Modal.Footer>
            <div className="mp-modal-footer">
              <button
                type="button"
                className="mp-modal-btn-cancel"
                onClick={() => setShowEditModal(false)}
                disabled={isUpdating}
              >
                Cancelar
              </button>
              <button
                type="submit"
                className="mp-modal-btn-submit"
                disabled={isUpdating}
              >
                {isUpdating ? (
                  <>
                    <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                    Actualizando...
                  </>
                ) : (
                  'Actualizar'
                )}
              </button>
            </div>
          </Modal.Footer>
        </Form>
      </Modal>
      {showCajaWithMoneyModal && (
        <IsCajaWithMoney
          id_workstation={currentWorkstation.workstation_id}
          show={showCajaWithMoneyModal}
          onClose={handleCajaWithMoneyModalClose}
        />
      )}
    </>
  );
};

export default EditWorkstation;


